import mixpanel, { Config } from 'mixpanel-browser';
import { analyticsConfig } from './config';

const enableRecording = import.meta.env.VITE_MODE === 'production';

const mixpanelConfig: Config = enableRecording
  ? {
      record_sessions_percent: 100,
      record_mask_text_selector: '',
      record_heatmap_data: true, // Not added to types yet: https://github.com/mixpanel/mixpanel-js/pull/500
      record_block_selector: '[id*="intercom"], [class*="intercom"]',
    }
  : {};

mixpanel.init(analyticsConfig.mixpanelProjectToken, mixpanelConfig);

export default mixpanel;
